import { createContext } from 'react'

export const CleverContext = createContext(null)
